import { RUNTIME_ENV } from '@cap/account';
import { isMobile } from '../uaHelper';

/**
 * 环境变量
 */
export const ENV = process.env.VUE_APP_ENV || RUNTIME_ENV.PROD;

/**
 * 是否prod环境，包括st、prod
 */
export const IS_PROD = [
  RUNTIME_ENV.ST,
  RUNTIME_ENV.STAGING,
  RUNTIME_ENV.PROD,
  RUNTIME_ENV.PRODUCTION,
].includes(ENV as RUNTIME_ENV);

export function loginConfig() {
  return {
    risk_platform: isMobile() ? 3 : 1,
    risk_partner: 359,
    risk_app: 216,
    risk_level: 4,
    uuid: '',
    isMobile: isMobile(),
    sameSite: true,
  };
}
